import React, { memo } from 'react';
import PopupContainer from '../../../components/popup';
import { IsListNotEmpty } from '../../../utils'
import { AddUser, GetRolesLookup, GetUserDetails, UpdateDoctor } from '@/api/endpoints';
import { LoadListDefault, useGet, usePost, useUpdate } from '../../../api/hooks';
import InputField from '../../../components/formFields/InputField';
import useForm from '../../../hooks/useForm';
import { DropDown } from '@/components/Exporter';
import { Validations } from '@/utils/validations';
import { errorToast } from '@/utils/toasters';

const modalName = "CUUserModal"

const CUUser = ({ rowId, modalID }) => {

    const { formHandler, onSubmit, onReset } = useForm()
    const { onPost } = usePost(AddUser)
    const { onUpdate } = useUpdate(UpdateDoctor)

    const { result: userInfo, isPending: isUserInfoPending } = useGet({
        ...LoadListDefault,
        params: [rowId],
        allowFetch:  !!rowId,
        endPoint: GetUserDetails
    })


    const handleApply = () => {
        onSubmit(d => {

            if (Validations?.isPasswordsMatched(d.password, d.confirmPassword) && !rowId) return errorToast("passwords-do-not-match")

            const data = {
                ...d,
                roleId: d.role?.value
            }

          return  rowId ? onUpdate(rowId, data) : onPost(data)
        })


    }


    return (
        <PopupContainer
            name={modalName + rowId}
            recordID={rowId}
            title={rowId ? "edit-user" : "adit-user"}
            onApply={handleApply}
            resetAllFields={rowId ? undefined : onReset}
            modalID={modalID}
            btnName={rowId ? "Update" : "Save"}
        >
            <InputField lang="any" formHandler={formHandler} name={"name"} defaultValue={userInfo?.name} isLoading={isUserInfoPending} />
            <InputField lang="any" formHandler={formHandler} name={"phoneNumber"} defaultValue={userInfo?.phoneNumber} isLoading={isUserInfoPending} />
            <InputField lang="any" formHandler={formHandler} name={"email"} defaultValue={userInfo?.email} isLoading={isUserInfoPending} />

            <div className="col-12 row">
                <InputField lang="any" className="pass" isRequired={!rowId} formHandler={formHandler} name={"password"} defaultValue={userInfo?.password} isLoading={isUserInfoPending} />
                <InputField lang="any" className="pass" isRequired={!rowId} formHandler={formHandler} name={"confirmPassword"} defaultValue={userInfo?.confirmPassword} isLoading={isUserInfoPending} />
            </div>

            <DropDown isMulti={false} endPoint={GetRolesLookup} formHandler={formHandler} label={"role"} defaultValue={userInfo?.roleId} />

        </PopupContainer>
    );
}

export default memo(CUUser);
